import React, { useEffect } from "react";
import { CUSTOM_MESSAGES, LABEL } from "../../../veriables";
import cn from "classnames";
import style from "./tip.module.scss";
import TipsConfirmPopUp from "@containers/ViewReceipt/tipsConfirmationPopUpRevamp";
import Keyboard from "@components/KeyboardV2";
import { TouchableButton, TouchableDiv } from "../../common/Touchable/index";


const OtherAmount = (
    enableOtherAmount,
    enableOtherPercent,
    totalVisible,
    otherAmountName,
    setBtnPrimary,
    btnPrimary,
    value,
    checkDecimal,
    tipAmount,
    getTipAmount,
    totalAmountForTip,
    setActive,
    setTotalVisibleVal,
    setTipAmount,
    tipvalue,
    currenySymbol,
    onClickBtn,
    onChangePersentage,
    serverAppTheme,
    hasAutoGratuity,
    showCheckSeat,
    setInputName,
    isTipOnlyEnabled,
) => {
    let authInfo = JSON.parse(window.sessionStorage.getItem('auth'))
    const handleBlur = () => {
        const element = document.querySelector(`#${otherAmountName}`);
        element?.blur();
    };
    return (
        <div className="col-12 px-0 h-100">
            {enableOtherAmount && enableOtherPercent && !isTipOnlyEnabled && (
                <div className={cn("col-12 px-0 d-flex justify-content-center py-2 fs-20 fw-600", authInfo?.tipInfo?.disablePresetTip ? 'h-12' : 'h-15')}>
                    <TouchableDiv
                        id="btnTotal"
                        className={cn("col-6 px-0 rounded-left d-flex justify-content-center align-items-center")}
                        style={Object.assign(
                            {
                                border: `1px solid ${serverAppTheme?.itemFacts}`,
                                outline: 'none'
                            },
                            btnPrimary.isAmount,
                        )}
                        tabIndex="0"
                        role="button"
                        onClick={() => {
                            setActive("");
                            setTotalVisibleVal(true);
                            setBtnPrimary({
                                isAmount: {
                                    background: serverAppTheme?.selected,
                                    color: "#000",
                                },
                                isPercent: {
                                    background: "transparent",
                                    color: serverAppTheme?.primary_text,
                                },
                            });
                            setTipAmount(0);
                        }}
                        rippleEffect={true}
                    >
                        {LABEL().TIP_AMOUNT}
                    </TouchableDiv>
                    <TouchableDiv
                        id="btnItemisd"
                        className={cn("col-6 px-0 rounded-right d-flex justify-content-center align-items-center")}
                        style={Object.assign(
                            {
                                border: `1px solid ${serverAppTheme?.itemFacts}`,
                                outline: 'none'
                            },
                            btnPrimary.isPercent,
                        )}
                        tabIndex="0"
                        role="button"
                        onClick={() => {
                            setActive("");
                            setTotalVisibleVal(false);
                            setBtnPrimary({
                                isAmount: {
                                    background: "transparent",
                                    color: serverAppTheme?.primary_text,
                                },
                                isPercent: {
                                    background: serverAppTheme?.selected,
                                    color: "#000",
                                },
                            });
                            setTipAmount(0);
                        }}
                        rippleEffect={true}
                    >
                        {LABEL().TIP_PERCENT}
                    </TouchableDiv>
                </div>
            )}
            {totalVisible && enableOtherAmount ? (
                <div className={cn("col-12 px-0", !authInfo?.tipInfo?.disablePresetTip && 'pt-2', showCheckSeat() && !authInfo?.tipInfo?.disablePresetTip && 'h-85')}>
                    <div className="col-12 h-18 px-0 fs_24 fw-600 d-flex w-100 position-relative align-items-center">
                        <input
                            className="w-100 h-100 form-control-lg fs_24 pl-2 text-left d-flex align-items-center"
                            name={otherAmountName}
                            value={value} // value
                            onFocus={() => {
                                handleBlur();
                                setInputName(`${otherAmountName}`);
                            }}
                            style={{
                                background: serverAppTheme?.inputBg,
                                border: 'none',
                                borderBottom: serverAppTheme?.inputBorder_Bottom,
                                color: serverAppTheme?.primary_text,
                                "--placeholder-color": serverAppTheme?.input_placeholder,
                            }}
                            id={otherAmountName}
                            placeholder="$"
                        />
                        { !isTipOnlyEnabled && (
                            <span className="align-items-center d-flex text-left position-absolute" style={{ right: '1rem' }}>
                            &nbsp;={" "}
                            {checkDecimal(
                                ((100 * tipAmount) / getTipAmount(totalAmountForTip)).toFixed(
                                    1,
                                ),
                            )}
                            %
                        </span>
                        )}
                    </div>
                    <div className={cn("col-12 text-center pt-2 px-0")}>
                        <Keyboard
                            onClickBtn={onClickBtn}
                            type="numericDot"
                            isClr
                            maxLength={100}
                            isDot
                            customClass={"fs-30 pb-1 pl-1"}
                        />
                    </div>{" "}
                </div>
            ) : (
                <div className={cn("col-12 px-0", !authInfo?.tipInfo?.disablePresetTip && 'pt-2', showCheckSeat() && !authInfo?.tipInfo?.disablePresetTip && 'h-85')}>
                    <div
                        className="col-12 h-18 px-0 fs_24 fw-600 d-flex w-100 position-relative align-items-center"
                        tabIndex="0"
                        role="button"
                        onMouseDown={(e) => e.preventDefault()}
                    >
                        <input
                            className="w-100 h-100 fs_24 form-control-lg text-left"
                            name={otherAmountName}
                            value={tipvalue} // percent
                            onFocus={() => {
                                handleBlur();
                            }}
                            style={{
                                background: serverAppTheme?.inputBg,
                                border: 'none',
                                borderBottom: serverAppTheme?.inputBorder_Bottom,
                                color: serverAppTheme?.primary_text,
                                "--placeholder-color": serverAppTheme?.input_placeholder,
                            }}
                            placeholder="%"
                        />
                        <span className="align-items-center d-flex text-left position-absolute" style={{ right: '1rem' }}>
                            &nbsp;= {currenySymbol}
                            {Number(tipAmount === "." ? 0 : tipAmount).toFixed(2)}
                        </span>
                    </div>
                    <div className={cn("col-12 px-0 text-center pt-2 px-0")}>
                        <Keyboard 
                            onClickBtn={onChangePersentage}
                            type="numericDot"
                            isClr
                            maxLength={100}
                            isDot
                            customClass={"fs-30 pb-1 pl-1"}
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

const Tips = ({
    tableData,
    currenySymbol,
    tipsList,
    tipList,
    active,
    serverAppTheme,
    mewVal,
    getTipAmount,
    setTotalVisibleVal,
    handleKeyboardValue,
    handleButtonClick,
    setotherAmount,
    tipAmount,
    disableOtherTip,
    enableOtherAmount,
    enableOtherPercent,
    otherAmount,
    setActive,
    setTipAmount,
    setValue,
    setTipvalue,
    setInputs,
    inputs,
    inputName,
    isCounter,
    totalAmountForTip,
    authInfo,
    showNoTipModal,
    setShowNoTipModal,
    handleOtherAmountContinue,
    validateTipsForCredit,
    handleCheck,
    selectedPayment,
    otherAmountName,
    setBtnPrimary,
    btnPrimary,
    totalVisible,
    value,
    checkDecimal,
    tipvalue,
    onClickBtn,
    onChangePersentage,
    applyTipForPayment,
    hasAutoGratuity,
    showCheckSeat,
    setInputName,
    isDriveThru,
    isTipOnlyEnabled,
    validateTipForTipOnly,
    paymentCheckData,
    getTipOnlyOtherAmount,
    ...props
}) => {
    
    const handleOtherAmountOrPercent = () => {
        setotherAmount(!otherAmount);
        setActive('');
        setTipAmount(0);
        setValue('');
        setTipvalue('');
        setInputs({
            ...inputs,
            [inputName]: ''
        });
    }

    useEffect(() => {
        if (isTipOnlyEnabled && getTipOnlyOtherAmount) {
            handleOtherAmountOrPercent();
            setTipAmount(getTipOnlyOtherAmount)
        }
    }, [isTipOnlyEnabled, getTipOnlyOtherAmount]);

  const handleTip = () => {
    // For Tip Only flow, always validate via validateTipForTipOnly regardless of input state
    // (inputs may be cleared on back navigation, but tipAmount state is always current)
    if (isTipOnlyEnabled) {
      validateTipForTipOnly(
        Number(tipAmount === "." ? 0 : tipAmount).toFixed(2)
      );
      return;
    }
    (!isCounter || !isDriveThru) && selectedPayment !== "giftCard"
      ? (active == "" || otherAmount) && inputs.otheramountname != ""
        ? handleOtherAmountContinue(
          "tips",
          (totalVisible && enableOtherAmount)
            ? checkDecimal(
              ((100 * tipAmount) / getTipAmount(totalAmountForTip)).toFixed(
                1,
              )
            )
            : tipvalue.slice(0, -1),
          Number(tipAmount === "." ? 0 : tipAmount).toFixed(2)
        ) // more than 30%
        : validateTipsForCredit(
          authInfo?.tipInfo?.ruleType == 2
            ? Number(tipAmount)
            : ((getTipAmount(totalAmountForTip) * active) / 100)?.toFixed(
              2,
            ),
        ) // less than 30%
      : handleCheck("tips");
  }

    return (
        <div className="col-12 px-0 h-100">
            <div
                className={cn("col-12 px-0 text-center h-18")}
            >
                {!isTipOnlyEnabled && (
                  <div className="col-12 px-0 fs_28 fw-600 d-flex justify-content-center">
                    <div className="pr-3">
                        {LABEL().TIP_CHECKTOTAL}
                    </div>
                    <div>
                        {currenySymbol}
                        {tableData &&
                            (tableData.totalAmount - tableData.paidAmount)?.toFixed(2)}
                    </div>
                </div>
                )}
                <div className={cn("col-12 px-0 fw-400 d-flex justify-content-center", hasAutoGratuity ? LABEL().TIP_HAS_AUTO_GRATUITY_SELECT?.length > 35 ? 'fs_32' : 'fs_48' : 'fs_48', style.fw300)}>
                    <div className="pr-3">
                        Due
                    </div>
                    <div>
                        {currenySymbol}
                        {tableData &&
                            (
                                tableData.totalAmount -
                                tableData.paidAmount +
                                (inputs.otheramountname != "" || authInfo?.tipInfo?.ruleType == 2
                                    ? Number(tipAmount)
                                    : (getTipAmount(totalAmountForTip) *
                                        (active === "otherAmount" ? "" : active)) /
                                    100)
                            )?.toFixed(2)}
                    </div>
                </div>
                <div className={cn("col-12 px-0 fw-500", hasAutoGratuity ? LABEL().TIP_HAS_AUTO_GRATUITY_SELECT?.length > 35 ? 'fs_16' : 'fs_20' : 'fs_20')}>{hasAutoGratuity ? LABEL().TIP_HAS_AUTO_GRATUITY_SELECT : (isTipOnlyEnabled ? LABEL().TIP_ENTER : LABEL().TIP_SELECT)}</div>
            </div>
            {(hasAutoGratuity ? !authInfo?.autoGratuityTipInfo?.disablePresetTip : !authInfo?.tipInfo?.disablePresetTip) && !isTipOnlyEnabled && (
                <div className="col-12 px-0 h-12 py-1">
                    <div className={cn("col-12 px-0 d-flex h-100 align-items-center justify-content-between fw-600")}>
                        {tipList?.map((item, index) => (
                            <TouchableDiv
                                key={Number(item.key?.toFixed(1))}
                                role="presentation"
                                className={cn(
                                    "h-100 col-4",
                                    index === 0
                                        ? "pl-0 pr-1"
                                        : index === tipList?.length - 1
                                            ? "pr-0 pl-1"
                                            : "px-0"
                                )}
                                onClick={(event) => {
                                    event.preventDefault();
                                    setTotalVisibleVal(true);
                                    setBtnPrimary({
                                        isAmount: {
                                            background: serverAppTheme?.selected,
                                            color: "#000",
                                        },
                                        isPercent: {
                                            background: "transparent",
                                            color: serverAppTheme?.primary_text,
                                        },
                                    });
                                    handleKeyboardValue("");
                                    handleButtonClick(Number(item.key?.toFixed(1)));
                                    setotherAmount(false);
                                }}
                            >
                                <div
                                    className={cn(
                                        "col-12 px-0 h-100 rounded d-flex justify-content-center align-items-center flex-column",
                                        item.key === active &&
                                        "od-primary-btn-bg-color od-primary-btn-font-color"
                                    )}
                                    style={
                                        item.key === active
                                            ? {
                                                background: serverAppTheme?.secondaryBtn,
                                                color: serverAppTheme?.btn_font_color
                                            }
                                            : {
                                                background: serverAppTheme?.tip_tile,
                                                border: `1px solid ${serverAppTheme?.tip_border}`,
                                                color: serverAppTheme?.primary_text,
                                            }
                                    }
                                >
                                    <div className="fs_32">
                                        {item?.ruleType === 2 && "$"}
                                        {item?.ruleType === 1
                                            ? mewVal(item.key)
                                            : item.key?.toFixed(2)}
                                        {item?.ruleType === 1 && "%"}
                                    </div>

                                    {item.ruleType === 1 && ![4, 5].includes(item.id) && (
                                        <div className="fs_20">
                                            {LABEL().CURRENCY_SYMBOL}
                                            {(
                                                (getTipAmount(totalAmountForTip) * Number(item.key)) /
                                                100
                                            )?.toFixed(2)}
                                        </div>
                                    )}

                                    {item.key === active && [4, 5].includes(item.id) && (
                                        <div className="fs_32">
                                            ({LABEL().CURRENCY_SYMBOL}
                                            {Number(tipAmount)?.toFixed(2)})
                                        </div>
                                    )}
                                </div>
                            </TouchableDiv>
                        ))}
                    </div>
                </div>
            )}

            <div className={cn("col-12 px-0 text-center", (hasAutoGratuity ? (authInfo?.autoGratuityTipInfo?.disablePresetTip ? 'h-64' : 'h-52') : ((authInfo?.tipInfo?.disablePresetTip || isTipOnlyEnabled) ? 'h-71' : 'h-52')))}>
                {(() => {
                    const showOtherTip =
                    disableOtherTip && (enableOtherAmount || enableOtherPercent) && !otherAmount && !isTipOnlyEnabled;
                    
                    const showNoTip =
                        (hasAutoGratuity
                            ? (!authInfo?.autoGratuityTipInfo?.disablePresetTip &&
                                !authInfo?.autoGratuityTipInfo?.disableNoTip)
                            : (!authInfo?.tipInfo?.disablePresetTip &&
                                !authInfo?.tipInfo?.disableNoTip)) && !otherAmount && !isTipOnlyEnabled;

                    const justifyClass = showOtherTip && showNoTip
                        ? "justify-content-between"
                        : "justify-content-center";

                    return (
                        <div className={cn("d-flex pt-2", justifyClass)}>
                            {showOtherTip && (
                                <TouchableDiv
                                    role="presentation"
                                    onClick={(event) => {
                                        event.preventDefault();
                                        handleOtherAmountOrPercent();
                                    }}
                                    className="fs_24 mb-10 text-underline fw-600"
                                >
                                    {LABEL().TIP_OTHER}
                                </TouchableDiv>
                            )}

                            {showNoTip && (
                                <div>
                                    <TouchableDiv
                                        className="fs_24 text-underline fw-600"
                                        tabIndex="0"
                                        role="button"
                                        onClick={(event) => {
                                            event.preventDefault();
                                            setShowNoTipModal((prev) => ({ ...prev, state: true }));
                                        }}
                                    >
                                        {hasAutoGratuity
                                            ? LABEL().TIP_HAS_AUTO_GRATUITY_NO_TIP
                                            : LABEL().TIP_NO_TIP}
                                    </TouchableDiv>
                                    <TipsConfirmPopUp
                                        isOpen={showNoTipModal.state}
                                        onClose={() =>
                                            setShowNoTipModal((prev) => ({ ...prev, state: false }))
                                        }
                                        tipAmount={0}
                                        totalAmountForTip={tableData?.subTotalAmount?.toFixed(2)}
                                        onSubmitTips={() => {
                                            setTipAmount(0);
                                            setShowNoTipModal((prev) => ({
                                                ...prev,
                                                state: false,
                                                tip: "No tip",
                                            }));
                                            handleButtonClick("");
                                            !isCounter && selectedPayment !== "giftCard"
                                                ? applyTipForPayment({
                                                    tipType: 0,
                                                    tipAmount: 0,
                                                    tipTypeValue: 0,
                                                })
                                                : handleCheck("tips", "No Tip");
                                        }}
                                    />
                                </div>
                            )}
                        </div>
                    );
                })()}

                {
                    (otherAmount || (hasAutoGratuity ? authInfo?.autoGratuityTipInfo?.disablePresetTip : authInfo?.tipInfo?.disablePresetTip) || isTipOnlyEnabled) &&
                    OtherAmount(
                        enableOtherAmount,
                        enableOtherPercent,
                        totalVisible,
                        otherAmountName,
                        setBtnPrimary,
                        btnPrimary,
                        value,
                        checkDecimal,
                        tipAmount,
                        getTipAmount,
                        totalAmountForTip,
                        setActive,
                        setTotalVisibleVal,
                        setTipAmount,
                        tipvalue,
                        currenySymbol,
                        onClickBtn,
                        onChangePersentage,
                        serverAppTheme,
                        hasAutoGratuity,
                        showCheckSeat,
                        setInputName,
                        isTipOnlyEnabled
                    )
                }
            </div>
            {!isTipOnlyEnabled && (
            <div className={cn("col-12 px-0 h-8 fs_12 d-flex align-items-end", style.disclamier)}>
                {hasAutoGratuity ? CUSTOM_MESSAGES().TIP_HAS_AUTO_GRATUITY_DISCLAIMER : CUSTOM_MESSAGES().TIP_DISCLAIMER}
            </div>
            )}
            <div className="col-12 px-0 h-10 d-flex justify-content-center align-items-end">
                <TouchableButton
                    type="button"
                    className={cn(
                        'btn-ripple w-100 rounded od-primary-btn-bg-color od-primary-btn-font-color col-12', style.btn
                    )}
                    style={{
                        background: serverAppTheme?.secondaryBtn,
                        color: serverAppTheme?.btn_font_color,
                    }}
                    onClick={(e) => {
                        e.preventDefault();
                        handleTip();
                    }}
                    rippleEffect={true}
                >
                    <div className={cn(isCounter || isDriveThru ? 'fs-22' : 'fs_28 fw-600')}>
                        {LABEL().CHECK_PRESENTER_PAY}
                    </div>
                </TouchableButton>
            </div>
        </div>
    );
};

export default Tips;
